module.exports = __webpack_public_path__ + "00_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/00_mole.png
// module id = +3YE
// module chunks = 0